import { useSelector } from "react-redux";
import useStyles from "./style";
import { Box, Flex } from "@mantine/core";
import moment from "moment";

const ActiveSubCard = () => {
  const { classes, cx } = useStyles();
  const { profile } = useSelector((state) => state.profile);
  return (
    <Box>
      <p className={classes.hdng}>Active subscription</p>
      <Box className={classes.activeSubCard}>
        <p className={classes.cardHdng}>Plan Details</p>
        <Flex className={classes.infoWrapper}>
          <Flex className={classes.labelValueWrapper}>
            <p className={classes.label}>Plan:</p>
            <p className={classes.label}>
              {profile?.subscription?.packageId?.name}
            </p>
          </Flex>
          <Flex className={classes.labelValueWrapper}>
            <p className={classes.label}>Status:</p>
            <span
              className={cx(
                classes.subStatus,
                !profile?.subscription?.isActive
                  ? classes.inactiveSubStatus
                  : "",
              )}
            >
              {profile?.subscription?.isActive ? "Active" : "Inactive"}
            </span>
          </Flex>
          {/* <Flex className={classes.labelValueWrapper}>
            <p className={classes.label}>Next Renewal:</p>
            <p className={classes.value}>
              {moment(profile?.subscription?.expiredAt).format("MMMM D, YYYY")}
            </p>
          </Flex> */}
        </Flex>
      </Box>
    </Box>
  );
};

export default ActiveSubCard;
